module.exports = __webpack_public_path__ + "static/salon-pasajeros---acabado-techo-f57811e89baa5941953239fbf8bbb5e6.jpg";